<script setup>

// Imports
import { defineLazyHydrationComponent } from '#imports'

// Props
const props = defineProps({
  block: {
    type: Object,
    default: () => ({})
  }
})

const LazyFaqDelight = defineLazyHydrationComponent(
  'visible',
  () => import('./faqDelightInteractive.vue')
)
</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
  <LazyFaqDelight :block="block" />
</template>

